export default __webpack_public_path__ + "static/confetti-5accd66896b23bb97d9295789728a074.png";